import React, { Component } from 'react';

// Material UI Library
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

function DeleteActionDialog(props) {
  return (
    <Dialog
      title="Confirm Deletion"
      actions={[<FlatButton
          label="Cancel"
          onTouchTap={props.cancelDialog}
        />,
        <FlatButton
          label="Remove"
          secondary={true}
          onTouchTap={props.removeRequest}
        />,
      ]}
      open={props.isOpen}
    >
      Permanently delete {props.name} forever?
    </Dialog>
  );
}

export default DeleteActionDialog;



/** WEBPACK FOOTER **
 ** ./components/DeleteActionDialog.js
 **/